export default {
    search_placeholder: "Busca...",
    showing_results: "Exibindo {0} resultado",
    showing_results_plural: "Exibindo {0} resultados",
};
